export enum ClaimNoteMaxLengths {
  SubjectCharacters = 100,
  BodyCharacters = 4000,
}
